import React from "react";
import Marquee from "react-fast-marquee";
import { heroMarqueeImages } from "../../utils/data";

const HeroMarquee = () => {
  return (
    <section className="pb-12">
      <Marquee autoFill>
        {heroMarqueeImages.map((item) => (
          <div
            key={item.id}
            className="h-80 w-72 shadow-custom-shadow rounded-[1.25rem] bg-gradient-to-b from-[#e7f1ff] to-white ml-6"
          >
            <img
              src={item.image}
              alt={`illustration${item.id}`}
              id="illustration"
              className="h-full w-full object-cover"
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default HeroMarquee;
